import { defineMessages } from "react-intl";

import { Locale, Occupation, Role, Sex } from "lib/build/concepts";

export const genericMessages = defineMessages({
	yes: {
		id: "generic.yes",
		defaultMessage: "Igen"
	},
	no: {
		id: "generic.no",
		defaultMessage: "Nem"
	},
	add: {
		id: "generic.add",
		defaultMessage: "Hozzáadás"
	},
	before: {
		id: "generic.before",
		defaultMessage: "Előtt"
	},
	after: {
		id: "generic.after",
		defaultMessage: "Után"
	},
	back: {
		id: "generic.back",
		defaultMessage: "Vissza"
	},
	forward: {
		id: "generic.forward",
		defaultMessage: "Tovább"
	},
	skip: {
		id: "generic.skip",
		defaultMessage: "Kihagyás"
	},
	skipAll: {
		id: "generic.skip_all",
		defaultMessage: "Összes kihagyása"
	},
	cancel: {
		id: "generic.cancel",
		defaultMessage: "Mégse"
	},
	save: {
		id: "generic.save",
		defaultMessage: "Mentés"
	},
	saveAndNew: {
		id: "generic.save_and_new",
		defaultMessage: "Mentés és új"
	},
	delete: {
		id: "generic.delete",
		defaultMessage: "Törlés"
	},
	close: {
		id: "generic.close",
		defaultMessage: "Bezár"
	},
	search: {
		id: "generic.search",
		defaultMessage: "Keresés"
	},
	searchOnPage: {
		id: "generic.search_on_page",
		defaultMessage: "Keresés az oldalon"
	},
	noMatches: {
		id: "generic.no_matches",
		defaultMessage: "Nincs egyezés"
	},
	pleaseSelect: {
		id: "generic.please_select",
		defaultMessage: "Kérjük válasszon"
	},
	selectAll: {
		id: "generic.select_all",
		defaultMessage: "Az összes kiválassztása"
	},
	years: {
		id: "generic.years",
		defaultMessage: "{years} év"
	},
	yearsOfAge: {
		id: "generic.years_of_age",
		defaultMessage: "{years} éves"
	},
	days: {
		id: "generic.days",
		defaultMessage: "{days} napja"
	},
	months: {
		id: "generic.months",
		defaultMessage: "{months} hónapja"
	},
	somethingWentWrong: {
		id: "generic.error",
		defaultMessage: "Hiba történt!"
	},
	fixValidationErrors: {
		id: "generic.fix_vaildation_errors",
		defaultMessage: "Kérjük ellenőrizze az ürlap validációs hibáit!"
	},
	deleted: {
		id: "generic.deleted",
		defaultMessage: "Törölve"
	},
	modified: {
		id: "generic.modified",
		defaultMessage: "Módosítva"
	},
	status: {
		id: "generic.status",
		defaultMessage: "Státusz"
	},
	allAttachments: {
		id: "generic.all_attachments",
		defaultMessage: "Összes lelet"
	},
	medicalPractitionerComment: {
		id: "generic.medical_practitioner_comment",
		defaultMessage: "Kezelőorvos megjegyzése"
	},
	now: {
		id: "generic.now",
		defaultMessage: "Most"
	},
	changes: {
		id: "generic.changes",
		defaultMessage: "Változások"
	},
	timeFrom: {
		id: "generic.time_from",
		defaultMessage: "Idő (-tól)"
	},
	timeTo: {
		id: "generic.time_to",
		defaultMessage: "Idő (-ig)"
	},
	dateFrom: {
		id: "generic.date_from",
		defaultMessage: "Dátum (-tól)"
	},
	dateTo: {
		id: "generic.date_to",
		defaultMessage: "Dátum (-ig)"
	},
	information: {
		id: "form.error.information",
		defaultMessage: "Információk"
	}
});

export const genericErrorMessages = defineMessages({
	presence: {
		id: "form.error.presence",
		defaultMessage: "Ez a mező kötelező."
	},
	min: {
		id: "form.error.min",
		defaultMessage: "A minimális érték {min}."
	},
	max: {
		id: "form.error.max",
		defaultMessage: "A maximális érték {max}."
	},
	minExclusive: {
		id: "form.error.min_exclusive",
		defaultMessage: "A minimális érték >{minExclusive}."
	},
	maxExclusive: {
		id: "form.error.max_exclusive",
		defaultMessage: "A maximális érték <{maxExclusive}."
	},
	precision: {
		id: "form.error.precision",
		defaultMessage: "A tizedesjegyek maximális száma {precision}."
	},
	minLength: {
		id: "form.error.min_length",
		defaultMessage: "A minimális hossz {minLength}."
	},
	maxLength: {
		id: "form.error.max_length",
		defaultMessage: "A maximális hossz {maxLength}."
	},
	format: {
		id: "form.error.format",
		defaultMessage: "A mező formátuma nem megfelelő."
	},
	pattern: {
		id: "form.error.pattern",
		defaultMessage: "A mező formátuma nem megfelelő."
	}
});

export const orgMessages = defineMessages({
	neumann_medical: {
		id: "organization.neumann_medical",
		defaultMessage: "Semmelweis Egyetem Teszt"
	},
	htx_committee: {
		id: "organization.htx_committee",
		defaultMessage: "Szív Transzplantációs Bizottság"
	},
	ltx_committee: {
		id: "organization.ltx_committee",
		defaultMessage: "Máj Transzplantációs Bizottság"
	},
	ktx_budapest: {
		id: "organization.ktx_budapest",
		defaultMessage: "Budapesti Regionális Vese Transzplantációs Bizottság"
	},
	goki: {
		id: "organization.goki",
		defaultMessage: "Gottsegen György Országos Kardiológiai Intézet"
	},
	"22392421G": {
		id: "organization.22392421G",
		defaultMessage: "Nagykanizsa - Nemzeti Dialízis Központ"
	},
	"20124203": {
		id: "organization.20124203",
		defaultMessage: "PTE Gyermekklinika, Művese"
	},
	"01402370T": {
		id: "organization.01402370T",
		defaultMessage:
			"Semmelweis Egyetem Sebészeti Transzplantációs és Gasztroenterológiai Klinika"
	},
	"01A624200": {
		id: "organization.01A624200",
		defaultMessage: "MH Egészségügyi Központ Dialízis Központ"
	},
	"10724211": {
		id: "organization.10724211",
		defaultMessage: "Szent Margit Kórház Dialízis Központ"
	},
	"110074201": {
		id: "organization.110074201",
		defaultMessage: "B. Braun Avitum 8. számú Dialízis központ - Tatabánya"
	},
	"11223701": {
		id: "organization.11223701",
		defaultMessage: "Diaverum Dialízis Központ Bajcsy Kórház"
	},
	"160074216": {
		id: "organization.160074216",
		defaultMessage: "Diaverum Dialízis Központ Szolnok"
	},
	"11823703": {
		id: "organization.11823703",
		defaultMessage: "Uzsoki utcai Kórház Dialízis Központ"
	},
	"12723700": {
		id: "organization.12723700",
		defaultMessage: "Diaverum Dialízis Központ László Kórház"
	},
	"207424201": {
		id: "organization.207424201",
		defaultMessage: "Diaverum Dialízis Központ Keszthely"
	},
	"130064201": {
		id: "organization.130064201",
		defaultMessage: "B. Braun Avitum 14. számú Dialízis központ - Kistarcsa"
	},
	"130124231": {
		id: "organization.130124231",
		defaultMessage:
			"Semmelweis Egyetem Szakrendelő Intézet Dializáló Állomás"
	},
	"130223701": {
		id: "organization.130223701",
		defaultMessage: "Cegléd - Nemzeti Dialízis Központ"
	},
	"134824222": {
		id: "organization.134824222",
		defaultMessage: "Vác - Nemzeti Dialízis Központ"
	},
	"14023701": {
		id: "organization.14023701",
		defaultMessage: "Semmelweis Egyetem - Nemzeti Dialízis Központ"
	},
	"14024216": {
		id: "organization.14024216",
		defaultMessage:
			"SE ÁOK I. sz. Gyermekgyógyászati Klinika Vese és Művese Osztály"
	},
	"150323701": {
		id: "organization.150323701",
		defaultMessage: "B. Braun Avitum 12. számú Dialízis központ - Kisvárda"
	},
	"157074201": {
		id: "organization.157074201",
		defaultMessage:
			"B. Braun Avitum 2. számú Dialízis központ - Nyíregyháza"
	},
	"157074203": {
		id: "organization.157074203",
		defaultMessage:
			"B. Braun Avitum 18. számú Dialízis központ - Mátészalka"
	},
	"182524201": {
		id: "organization.182524201",
		defaultMessage:
			"B. Braun Avitum 6. számú Dialízis központ - Szombathely"
	},
	"190080150": {
		id: "organization.190080150",
		defaultMessage: "B. Braun Avitum 17. számú Dialízis központ - Ajka"
	},
	"190084201": {
		id: "organization.190084201",
		defaultMessage: "B. Braun Avitum 3. számú Dialízis Központ - Veszprém"
	},
	"223924211": {
		id: "organization.223924211",
		defaultMessage: "Szent István - Nemzeti Dialízis Központ"
	},
	"223924214": {
		id: "organization.223924214",
		defaultMessage: "Péterfy I - Nemzeti Dialízis Központ"
	},
	"223924215": {
		id: "organization.223924215",
		defaultMessage: "Eger - Nemzeti Dialízis Központ"
	},
	"223924217": {
		id: "organization.223924217",
		defaultMessage: "Esztergom - Nemzeti Dialízis Központ"
	},
	"22392421D": {
		id: "organization.22392421D",
		defaultMessage: "Salgótarján - Nemzeti Dialízis Központ"
	},
	"22392421K": {
		id: "organization.22392421K",
		defaultMessage: "Miskolc - Nemzeti Dialízis Központ"
	},
	"223924233": {
		id: "organization.223924233",
		defaultMessage: "Ózd - Nemzeti Dialízis Központ"
	},
	"223924234": {
		id: "organization.223924234",
		defaultMessage: "Sátoraljaújhely - Nemzeti Dialízis Központ"
	},
	"223924236": {
		id: "organization.223924236",
		defaultMessage: "Hatvan - Nemzeti Dialízis Központ"
	},
	"223924237": {
		id: "organization.223924237",
		defaultMessage: "Péterfy II - Nemzeti Dialízis Központ"
	},
	"240523701": {
		id: "organization.240523701",
		defaultMessage: "Nephrocentrum Alapítvány Művese Központja"
	},
	"312524211": {
		id: "organization.312524211",
		defaultMessage: "B. Braun Avitum 1. számú Dialízis központ - Budapest"
	},
	"42720170": {
		id: "organization.42720170",
		defaultMessage: "B. Braun Avitum 5. számú Dialízis központ - Békéscsaba"
	},
	"70123722": {
		id: "organization.70123722",
		defaultMessage:
			"B. Braun Avitum 9. számú Dialízis központ - Székesfehérvár"
	},
	"74024202": {
		id: "organization.74024202",
		defaultMessage:
			"B. Braun Avitum 13. számú Dialízis központ - Dunaújváros"
	},
	"80123701": {
		id: "organization.80123701",
		defaultMessage: "B. Braun Avitum 11. számú Dialízis központ - Győr"
	},
	"80264201": {
		id: "organization.80264201",
		defaultMessage: "Sopron - Nemzeti Dialízis Központ"
	},
	"93424201": {
		id: "organization.93424201",
		defaultMessage: "B. Braun Avitum 10. számú Dialízis központ - Debrecen"
	},
	"94024201": {
		id: "organization.94024201",
		defaultMessage: "Debrecen - Nemzeti Dialízis Központ"
	},
	"030123701": {
		id: "organization.030123701",
		defaultMessage: "Kecskemét - Nemzeti Dialízis Központ"
	},
	"94120540": {
		id: "organization.94120540",
		defaultMessage: "DEOEC Gyermekklinika"
	},
	kd_bajcsy: {
		id: "organization.kd_bajcsy",
		defaultMessage: "Diaverum Dialízis Központ Bajcsy Kórház"
	},
	kd_semmelweis_fmc: {
		id: "organization.kd_semmelweis_fmc",
		defaultMessage: "Semmelweis Egyetem - Nemzeti Dialízis Központ"
	},
	kd_semmelweis_gyermekklinika: {
		id: "organization.kd_semmelweis_gyermekklinika",
		defaultMessage:
			"SE ÁOK I. sz. Gyermekgyógyászati Klinika Vese és Művese Osztály"
	},
	kd_semmelweis_steg: {
		id: "organization.kd_semmelweis_steg",
		defaultMessage:
			"Semmelweis Egyetem Sebészeti Transzplantációs és Gasztroenterológiai Klinika"
	},
	kd_szent_imre: {
		id: "organization.kd_szent_imre",
		defaultMessage: "B. Braun Avitum 1. számú Dialízis központ - Budapest"
	}
});

export const modMessages = defineMessages({
	htx: {
		id: "module.htx",
		defaultMessage: "Szívtranszplantációs Döntéstámogatás"
	},
	ktx: {
		id: "module.ktx",
		defaultMessage: "Vesetranszplantációs Döntéstámogatás"
	},
	kd: {
		id: "module.kd",
		defaultMessage: "Dialízis"
	},
	ltx: {
		id: "module.ltx",
		defaultMessage: "Májtranszplantációs Döntéstámogatás"
	},
	htx_nm: {
		id: "module.htx_nm",
		defaultMessage: "Szívtranszplantációs Döntéstámogatás"
	},
	basic_health: {
		id: "module.basic_health",
		defaultMessage: "Basic Health"
	}
});

export const languageMessages = defineMessages<Locale>({
	hu: {
		id: "language.hu",
		defaultMessage: "Magyar"
	},
	en: {
		id: "language.en",
		defaultMessage: "Angol"
	}
});

export const roleMessages = defineMessages<Role>({
	ROLE_MEDICAL_PRACTITIONER: {
		id: "role.medical_practitioner",
		defaultMessage: "Páciens adat kezelő"
	},
	ROLE_REVIEWER: {
		id: "role.reviewer",
		defaultMessage: "Adat áttekintő"
	},
	ROLE_DECISION_MAKER: {
		id: "role.decision_maker",
		defaultMessage: "Döntéshozó"
	},
	ROLE_ADMIN: {
		id: "role.admin",
		defaultMessage: "Rendszer adminisztrátor"
	}
});

export const occupationMessages = defineMessages<Occupation>({
	DOCTOR: {
		id: "occupation.doctor",
		defaultMessage: "Orvos"
	},
	ASSISTANT: {
		id: "occupation.assistant",
		defaultMessage: "Asszisztens"
	},
	OTHER: {
		id: "occupation.other",
		defaultMessage: "Egyéb"
	}
});

export const sexMessages = defineMessages<Sex>({
	MALE: {
		id: "sex.male",
		defaultMessage: "Férfi"
	},
	FEMALE: {
		id: "sex.female",
		defaultMessage: "Nő"
	},
	OTHER: {
		id: "sex.other",
		defaultMessage: "Egyéb"
	}
});

export const yesNoMessages = defineMessages({
	YES: {
		id: "yes_no.yes",
		defaultMessage: "Igen"
	},
	NO: {
		id: "yes_no.no",
		defaultMessage: "Nem"
	}
});

export const positiveNegativeInProgressMessages = defineMessages({
	POSITIVE: {
		id: "positive_negative_in_progress.positive",
		defaultMessage: "Pozitív"
	},
	NEGATIVE: {
		id: "positive_negative_in_progress.negative",
		defaultMessage: "Negatív"
	},
	IN_PROGRESS: {
		id: "positive_negative_in_progress.in_progress",
		defaultMessage: "Folyamatban"
	}
});
